import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CartService } from '../services/cart';

@Injectable({
  providedIn: 'root'
})
export class CartGuard implements CanActivate {
  constructor(private cartService: CartService, private router: Router) { }

  canActivate(): Observable<boolean> {
    return this.cartService.cartChanges$.pipe(
      take(1),
      map(cart => cart.length > 0)
    );
  }
}
